module.exports = __webpack_public_path__ + "img/calendar-20_fill.4eb87110.svg";